/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 顧客情報入力フォーム画面パネル
 *
 * @author duan
 * @copyright Copyright 2021 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-customer-input-form-pane">

  <el-main class="main-area">
    <p class="customer-input-form-text" v-text="customerInputFormText"></p>
    <el-form ref="customerInputForm" :model="fastchatUserInfo" :rules="rules" @submit.native.prevent="doChatJoin">
      <div v-for="(item, index) in customerInputFormItems" :key="'customerInputFormItem' + index" class="form-item-container">
        <div v-if="item.matchingColumn.inputType == '0'">
          <div v-for="modelColumnKey in [getModelColumnKey(item)]" :key="modelColumnKey">
            <el-form-item :label="item.label" :prop="modelColumnKey" class="form-item">
              <el-input type="text" :disabled="!permissionInputCustomerInputForm" v-model="fastchatUserInfo[modelColumnKey]" :placeholder="item['matchingColumn']['placeholder'] || ''" class="custform-input"></el-input>
            </el-form-item>
          </div>
        </div>
        <el-form-item v-if="item.matchingColumn.inputType == '1'" :label="item.label" class="form-item" :required="item['matchingColumn']['required'] || false">
          <div style="display: flex; clear: left">
            <el-form-item :prop="item['matchingColumn']['columnName1']" class="form-item before-form-item">
              <el-input type="text" :disabled="!permissionInputCustomerInputForm" v-model="fastchatUserInfo[item['matchingColumn']['columnName1']]" :placeholder="item['matchingColumn']['column1Placeholder'] || ''" class="custform-double-input">
              </el-input>
            </el-form-item>
            <el-form-item :prop="item['matchingColumn']['columnName2']" class="form-item after-form-item">
              <el-input type="text" :disabled="!permissionInputCustomerInputForm" v-model="fastchatUserInfo[item['matchingColumn']['columnName2']]" :placeholder="item['matchingColumn']['column2Placeholder'] || ''" class="custform-double-input">
              </el-input>
            </el-form-item>
          </div>
        </el-form-item>
        <div v-if="item.matchingColumn.inputType == '2'">
          <div v-for="modelColumnKey in [getModelColumnKey(item)]" :key="modelColumnKey">
            <el-form-item :label="item.label" :prop="modelColumnKey" class="form-item">
              <div style="clear: left">
                <el-date-picker type="date" :placeholder="item['matchingColumn']['placeholder'] || '1970/01/01'" v-model="fastchatUserInfo[modelColumnKey]" :disabled="!permissionInputCustomerInputForm" format="yyyy/MM/dd" value-format="yyyy/MM/dd"
                  class="date-select" @blur="dateValidate($event, modelColumnKey)">
                </el-date-picker>
              </div>
            </el-form-item>
          </div>
        </div>
        <div v-if="item.matchingColumn.inputType == '3'">
          <div v-for="modelColumnKey in [getModelColumnKey(item)]" :key="modelColumnKey">
            <el-form-item :label="item.label" class="form-item" :required="item['matchingColumn']['required'] || false">
              <div style="display: flex; clear: left" v-if="item.matchingColumn.inputType == '3'">
                <el-form-item :prop="modelColumnKey" class="form-item radio">
                  <el-radio v-model="fastchatUserInfo[modelColumnKey]" label="1">{{item.matchingColumn.radioLabel1}}</el-radio>
                  <el-radio v-model="fastchatUserInfo[modelColumnKey]" label="2">{{item.matchingColumn.radioLabel2}}</el-radio>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
        </div>
        <div v-if="item.matchingColumn.inputType=='4'">
          <div v-for="modelColumnKey in [getModelColumnKey(item)]" :key="modelColumnKey">
            <el-form-item :label="item.label" :prop="modelColumnKey" class="form-item">
              <el-input type="textarea" :disabled="!permissionInputCustomerInputForm" v-model="fastchatUserInfo[modelColumnKey]" :rows="2" :placeholder="item['matchingColumn']['placeholder'] || ''" class="custform-textarea"></el-input>
            </el-form-item>
          </div>
        </div>
        <div v-if="item.matchingColumn.inputType=='5'">
          <div v-for="modelColumnKey in [getModelColumnKey(item)]" :key="modelColumnKey">
            <el-form-item :label="item.label" :prop="modelColumnKey" class="form-item">
              <div style="clear: left">
                <el-select v-model="fastchatUserInfo[modelColumnKey]" :disabled="!permissionInputCustomerInputForm" class="custform-select" popper-class="custform-select-dropdown">
                  <el-option v-for="elem in item.matchingColumn.options" :key="elem.value" :label="elem.label" :value="elem.value"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>
        </div>
        <div v-if="item.matchingColumn.inputType=='6'">
          <div v-for="modelColumnKey in [getModelColumnKey(item)]" :key="modelColumnKey">
            <el-form-item :label="item.label" :prop="modelColumnKey" class="form-item">
              <div style="clear: left">
                <el-date-picker type="datetime" :placeholder="item['matchingColumn']['placeholder'] || '1970/01/01 12:00:00'" v-model="fastchatUserInfo[modelColumnKey]" :disabled="!permissionInputCustomerInputForm" format="yyyy/MM/dd HH:mm:ss"
                  value-format="yyyy/MM/dd HH:mm:ss" class="datetime-select" @blur="dateTimeValidate($event, modelColumnKey)">
                </el-date-picker>
              </div>
            </el-form-item>
          </div>
        </div>
        <div v-if="item.matchingColumn.inputType=='7'">
          <div v-for="modelColumnKey in [getModelColumnKey(item)]" :key="modelColumnKey">
            <el-form-item :label="item.label" :prop="modelColumnKey" class="form-item">
              <div style="clear: left">
                <el-checkbox v-model="fastchatUserInfo[modelColumnKey]" :disabled="!permissionInputCustomerInputForm" true-label="ON" false-label="OFF" class="custform-checkbox">
                </el-checkbox>
              </div>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </el-main>

  <el-footer class=" footer-area" height="auto">
    <el-button type="primary" class="chat-join-button" :disabled="!permissionChatJoin" @click="doChatJoin">{{$t('チャットを始める')}}</el-button>
  </el-footer>

</el-container>
</template>

<script>
import {
  Container,
  Main,
  Footer,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Radio,
  DatePicker,
  Checkbox,
  Button
} from 'element-ui'
import ServiceUtil from '@/utils/ServiceUtil'
import ChatMessageConst from '@/constants/ChatMessageConst'
import DialogUtil from '@/utils/DialogUtil'
import CustomerInputFormConst from '@/constants/CustomerInputFormConst'

export default {
  name: 'FcCustomerInputFormPane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-footer': Footer,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-select': Select,
    'el-option': Option,
    'el-radio': Radio,
    'el-date-picker': DatePicker,
    'el-checkbox': Checkbox,
    'el-button': Button
  },
  data() {
    return {
      /**
       * FastChatユーザー情報
       * @type {Object}
       */
      fastchatUserInfo: {},
      /**
       * 顧客入力フォームルール
       * @type {Object}
       */
      rules: {},
      /**
       * FastChatサービス状態取得サービスをリクエスト中か
       * @type {Boolean}
       */
      requestingFindFastchatServiceStatus: false,
      /**
       * チャットユーザー情報のvalid状態
       * @type {Boolean}
       */
      validFastchatUserInfo: false,
      /**
       * 無効状態
       * @type {Boolean}
       */
      disabled: false
    }
  },
  beforeMount() {
    // 入力タイプにより、fastchatUserInfoとrulesを設定
    if (!this.customerInputFormItems) {
      return
    }
    this.customerInputFormItems.forEach((item, i) => {
      if (!item['matchingColumn'] || !item['matchingColumn']['inputType'] || !item['label']) {
        return
      }
      let inputType = item['matchingColumn']['inputType']
      let requiredFlg = item['matchingColumn']['required'] || false
      if (inputType === CustomerInputFormConst.INPUT_TYPE_INPUT || inputType === CustomerInputFormConst.INPUT_TYPE_TEXTAREA) {
        let modelColumnKey = this.getModelColumnKey(item)
        this.$set(this.fastchatUserInfo, modelColumnKey, '')
        this.rules[modelColumnKey] = [{
          required: requiredFlg,
          message: this.$t('{inputFormColumn} を入力してください', {
            inputFormColumn: item['label']
          }),
          trigger: 'blur'
        }]
        if (item['matchingColumn']['maxLength']) {
          this.rules[modelColumnKey].push({
            validator: this.validateInputMaxBytesLength(item['matchingColumn']['maxLength']),
            trigger: 'blur'
          })
        }
        if (item['matchingColumn']['validateRule']) {
          this.rules[modelColumnKey].push({
            pattern: item['matchingColumn']['validateRule'],
            message: item['matchingColumn']['invalidMessage'],
            trigger: 'blur'
          })
        }
      } else if (inputType === CustomerInputFormConst.INPUT_TYPE_DOUBLE_INPUT) {
        let modelColumnKey1 = item['matchingColumn']['columnName1']
        let modelColumnKey2 = item['matchingColumn']['columnName2']
        this.$set(this.fastchatUserInfo, modelColumnKey1, '')
        this.$set(this.fastchatUserInfo, modelColumnKey2, '')
        this.rules[modelColumnKey1] = [{
          required: requiredFlg,
          message: this.$t('{inputFormColumn} を入力してください', {
            inputFormColumn: item['label']
          }),
          trigger: 'blur'
        }]
        this.rules[modelColumnKey2] = [{
          required: requiredFlg,
          message: this.$t('{inputFormColumn} を入力してください', {
            inputFormColumn: item['label']
          }),
          trigger: 'blur'
        }]
        if (item['matchingColumn']['maxLength']) {
          this.rules[modelColumnKey1].push({
            validator: this.validateInputMaxBytesLength(item['matchingColumn']['maxLength']),
            trigger: 'blur'
          })
          this.rules[modelColumnKey2].push({
            validator: this.validateInputMaxBytesLength(item['matchingColumn']['maxLength']),
            trigger: 'blur'
          })
        }
      } else if (inputType === CustomerInputFormConst.INPUT_TYPE_DATE || inputType === CustomerInputFormConst.INPUT_TYPE_DATETIME ||
        inputType === CustomerInputFormConst.INPUT_TYPE_RADIO || inputType === CustomerInputFormConst.INPUT_TYPE_CHECKBOX) {
        let modelColumnKey = this.getModelColumnKey(item)
        this.$set(this.fastchatUserInfo, modelColumnKey, '')
        if (inputType === CustomerInputFormConst.INPUT_TYPE_CHECKBOX) {
          this.$set(this.fastchatUserInfo, modelColumnKey, 'OFF')
        }
        this.rules[modelColumnKey] = [{
          required: requiredFlg,
          message: this.$t('{inputFormColumn} を入力してください', {
            inputFormColumn: item['label']
          }),
          trigger: 'blur'
        }]
      } else if (inputType === CustomerInputFormConst.INPUT_TYPE_SELECT) {
        let modelColumnKey = this.getModelColumnKey(item)
        let defaultValue = ''
        let options = item['matchingColumn']['options']
        if (options != null && options[0] != null) {
          defaultValue = options[0].value
        }
        this.$set(this.fastchatUserInfo, modelColumnKey, defaultValue)
        this.rules[modelColumnKey] = [{
          required: requiredFlg,
          message: this.$t('{inputFormColumn} を入力してください', {
            inputFormColumn: item['label']
          }),
          trigger: 'blur'
        }]
        if (item['matchingColumn']['unselectedListData'] && requiredFlg) {
          this.rules[modelColumnKey].push({
            validator: this.validateUnselectedListData(item['matchingColumn']['unselectedListData'], options),
            trigger: 'blur'
          })
        }
      }
    })
  },
  mounted() {
    // チャットユーザー情報のvalid状態を更新
    this.validateFastchatUserInfoForm((valid) => {
      this.validFastchatUserInfo = valid
    })
  },
  updated() {
    // チャットユーザー情報のvalid状態を更新
    this.validateFastchatUserInfoForm((valid) => {
      this.validFastchatUserInfo = valid
    })
  },
  computed: {
    /**
     * 顧客入力画面の説明文
     * @return {string}
     */
    customerInputFormText() {
      return this.$config.customerInputFormConfig.customerInputFormText
    },
    /**
     * 顧客入力画面の項目
     * @return {Array}
     */
    customerInputFormItems() {
      return this.$config.customerInputFormConfig.customerInputFormItems
    },
    /**
     * 「チャットを始める」の実行が可能か
     * @return {Boolean}
     */
    permissionChatJoin() {
      return !this.requestingFindFastchatServiceStatus && this.validFastchatUserInfo && !this.disabled
    },
    /**
     * 顧客情報入力フォームへの入力が可能か
     * @return {Boolean}
     */
    permissionInputCustomerInputForm() {
      return !this.requestingFindFastchatServiceStatus && !this.disabled
    }
  },
  methods: {
    /**
     * チャットユーザー情報フォームのvalidate処理
     * @param  {Function} callback
     */
    validateFastchatUserInfoForm(callback) {
      this.$refs['customerInputForm'].validate((valid) => {
        callback(valid)
      })
    },
    /**
     * モデルのカラム名を取得
     * @param  {object} item
     */
    getModelColumnKey(item) {
      let modelColumnKey = ''
      if (!item['matchingColumn'] || !item['matchingColumn']['columnName']) {
        return modelColumnKey
      }
      modelColumnKey = item['matchingColumn']['columnName']
      if (modelColumnKey === 'custOptionData' && item['matchingColumn']['custOptionIndex']) {
        modelColumnKey = modelColumnKey + item['matchingColumn']['custOptionIndex']
      }
      return modelColumnKey
    },
    /**
     *日付の入力欄チェック
     */
    dateValidate(obj, modelColumnKey) {
      let dateReg = new RegExp(/^([12]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01]))$/)
      if (obj && obj.userInput && !obj.userInput.match(dateReg)) {
        // 日付の入力欄に日付フォーマット以外のものが入力された際にクリア
        this.fastchatUserInfo[modelColumnKey] = null
        obj.userInput = ''
      }
    },
    /**
     *日時の入力欄チェック
     */
    dateTimeValidate(obj, modelColumnKey) {
      let dateTimeReg = new RegExp(/^[0-9]{4}\/(0[1-9]|1[0-2])\/(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$/)
      if (obj && obj.userInput && !obj.userInput.match(dateTimeReg)) {
        // 日時の入力欄に日付フォーマット以外のものが入力された際にクリア
        this.fastchatUserInfo[modelColumnKey] = null
        obj.userInput = ''
      }
    },
    /**
     *input値の最大長をバイト単位でチェック
     */
    validateInputMaxBytesLength(maxLength) {
      return (rule, value, callback) => {
        if (value && maxLength) {
          if (this.isOverBytesLength(value, maxLength)) {
            callback(new Error(this.$t('入力された文字サイズが制限を超えています(最大{inputMaxLength}byte)', {
              inputMaxLength: maxLength
            })))
          } else {
            callback()
          }
        } else {
          callback()
        }
      }
    },
    /**
     * validate unselected list data
     */
    validateUnselectedListData(unselectedListData, options) {
      return (rule, value, callback) => {
        if (value && unselectedListData) {
          let optionSelected = options.find(item => item.value === value)
          if (optionSelected.label !== unselectedListData) {
            callback()
          } else {
              callback(new Error(this.$t('{label} 以外を選択してください', {
              label: optionSelected.label
            })))
          }
        } else {
          callback()
        }
      }
    },
    /**
     * 指定したバイト数を超えているか
     */
    isOverBytesLength(value, bytesLength) {
      let result = false
      if (value != null) {
        let currentLength = (value.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || []).length * 4
        if (currentLength > bytesLength) {
          return true
        }
        value = value.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')
        var len = value.length
        for (var i = 0; i < len; i++) {
          currentLength += Math.ceil(encodeURI(value.charAt(i)).length / 3)
          if (currentLength > bytesLength) {
            result = true
            break
          }
        }
      }
      return result
    },
    /**
     * 顧客入力フォームをクリア
     **/
    clearCustomerInputForm() {
      if (this.$refs['customerInputForm']) {
        this.$refs['customerInputForm'].resetFields()
      }
    },
    /**
     * 顧客入力フォームの情報を生成
     *
     */
    makeCustomerInfoJson() {
      // 顧客オプションがある場合、「custOptionTypeId」と「custOptionTypeInputType」の値を追加
      this.customerInputFormItems.forEach((item, i) => {
        if (!item['matchingColumn'] || !item['matchingColumn']['columnName']) {
          return
        }
        if (item['matchingColumn']['columnName'] === 'custOptionData' && item['matchingColumn']['custOptionIndex']) {
          if (item['matchingColumn']['custOptionTypeId']) {
            this.fastchatUserInfo['custOptionTypeId' + item['matchingColumn']['custOptionIndex']] = item['matchingColumn']['custOptionTypeId']
          }
          if (item['matchingColumn']['custOptionTypeInputType']) {
            this.fastchatUserInfo['custOptionTypeInputType' + item['matchingColumn']['custOptionIndex']] = item['matchingColumn']['custOptionTypeInputType']
          }
        }
      })
      return JSON.stringify(this.fastchatUserInfo)
    },
    /**
     * 「チャットを始める」処理
     */
    doChatJoin() {
      if (!this.permissionChatJoin) {
        return
      }
      this.validateFastchatUserInfoForm((valid) => {
        if (valid) {
          this.chatJoin()
        }
      })
    },
    /**
     * 「チャットを始める」処理
     */
    chatJoin() {
      ServiceUtil.request('findFastchatServiceStatusWithPreStartChat', null, {
        start: _ => {
          this.requestingFindFastchatServiceStatus = true
        },
        success: (responseData) => {
          if (responseData.status === ChatMessageConst.FASTCHAT_SERVICE_STATUS_QUIET_HOURS) {
            setTimeout(_ => {
              DialogUtil.showInfoDialog(responseData.message, _ => {
                this.$emit('chatWindowClose')
              })
            }, 0)
            return
          }
          this.$emit('chatJoinWithCustomerInfo', {
            customerInfoJson: this.makeCustomerInfoJson()
          })
        },
        error: (errorCode) => {
          DialogUtil.showErrorDialog(errorCode, _ => {
            this.$emit('chatWindowClose')
          })
        },
        end: _ => {
          this.requestingFindFastchatServiceStatus = false
        }
      })
    }
  }
}
</script>

<style scoped>
.fc-customer-input-form-pane {
  height: 0px;
}

.fc-customer-input-form-pane .form-item.radio {
  width: 100%;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.footer-area {
  padding: 10px;
  background: #99a9bf;
}

.form-item {
  margin-bottom: 0;
}

.chat-join-button {
  width: 100%;
}

.close-button {
  background: transparent;
  border: none;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/customerInputForm/FcCustomerInputFormPane.vue